import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'batp-press-image',
  templateUrl: './press-image.component.html',
  styleUrls: ['./press-image.component.css']
})
export class PressImageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
